// extracted by mini-css-extract-plugin
export default {"container":"SetupCredentialsPage_container__S2q0Q","shine":"SetupCredentialsPage_shine__YOSGv"};